var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0.25C19.0035 0.25 20 1.40112 20 2.82143V4.10714H0V2.82143C0 1.40112 0.994792 0.25 2.22222 0.25H17.7778ZM20 15.6786C20 17.0969 19.0035 18.25 17.7778 18.25H2.22222C0.994792 18.25 0 17.0969 0 15.6786V7.96429H20V15.6786ZM3.88889 13.1071C3.58333 13.1071 3.33333 13.3964 3.33333 13.75C3.33333 14.1036 3.58333 14.3929 3.88889 14.3929H6.11111C6.41667 14.3929 6.66667 14.1036 6.66667 13.75C6.66667 13.3964 6.41667 13.1071 6.11111 13.1071H3.88889ZM8.33333 14.3929H12.7778C13.0833 14.3929 13.3333 14.1036 13.3333 13.75C13.3333 13.3964 13.0833 13.1071 12.7778 13.1071H8.33333C8.02778 13.1071 7.77778 13.3964 7.77778 13.75C7.77778 14.1036 8.02778 14.3929 8.33333 14.3929Z",
    fill: "#DADEE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.2b5979d66bbfe6e1ac38a6273e4a6cbc.svg";
export { ForwardRef as ReactComponent };